import { Alert } from 'antd';
import React from 'react';
import HeadingTypography from '../Typography/Heading';
import TextTypography from '../Typography/Text';
import { CloseOutlined } from '@ant-design/icons';

interface AlertProps {
    classNames?: string;
    error: { type: 'error' | 'success' | 'info' | 'warning' | ''; message: string };
    setError: (data: { type: 'error' | 'success' | 'info' | 'warning' | ''; message: string }) => void;
}

const AlertBar: React.FC<AlertProps> = ({ error, setError, classNames }) => {
    return (
        <>
            {error.type ? (
                <div className="pb-5">
                    <Alert
                        className="pt-[6px] pb-[6px] antd-alert-custom"
                        message={
                            <HeadingTypography fontSize={12} classNames=" font-normal">
                                Error
                            </HeadingTypography>
                        }
                        description={
                            <TextTypography classNames="font-normal" fontSize={12}>
                                {error.message}
                            </TextTypography>
                        }
                        type={error.type}
                        closable
                        closeIcon={
                            <div className="pt-2">
                                <CloseOutlined />
                            </div>
                        }
                        onClose={() => {
                            setError({ type: '', message: '' });
                        }}
                    />
                </div>
            ) : null}
        </>
    );
};

export default AlertBar;
